"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.adminPage = adminPage;

var _request = _interopRequireDefault(require("@/utils/request")); /* 系统管理 相关api */

function adminPage(params) {
  return (0, _request.default)({
    url: '/api/admin/page',
    method: 'get',
    params: params // get不能使用data
  });
}